import * as Yup from "yup";

export const initialValues = (data) => {
  return {
    ...data,
  };
};

export const structure = (t) => [
  {
    head: "",
    width: "100%",
    list: [
      {
        name: "code",
        kind: "input",
        type: "text",
        label: `${t ? t("promo_codes.code") : "Code"}*`,
        width: "47%",
        placeholder: t ? t("promo_codes.enter_promo_code") : "Enter promo code",
      },
      {
        name: "discount_percentage",
        kind: "input",
        type: "number",
        label: `${t ? t("promo_codes.discount_percentage") : "Discount Percentage"}*`,
        width: "47%",
        placeholder: t ? t("promo_codes.enter_discount_percentage") : "Enter discount percentage",
        EndAdornment: <p style={{ fontSize: "18px", color: "#1A1A1A" }}>%</p>,
      },
      {
        name: "max_discount_amount",
        kind: "input",
        type: "number",
        label: `${t ? t("promo_codes.max_discount") : "Max Discount Amount"}*`,
        width: "47%",
        placeholder: t ? t("promo_codes.enter_max_discount") : "Enter max discount amount",
        EndAdornment: <p style={{ fontSize: "18px", color: "#1A1A1A" }}>SAR</p>,
      },
      {
        name: "min_order_value",
        kind: "input",
        type: "number",
        label: `${t ? t("promo_codes.min_order_value") : "Min Order Value"}*`,
        width: "47%",
        placeholder: t ? t("promo_codes.enter_min_order_value") : "Enter min order value",
        EndAdornment: <p style={{ fontSize: "18px", color: "#1A1A1A" }}>SAR</p>,
      },
      {
        name: "expiry_date",
        kind: "input",
        type: "datetime-local",
        label: `${t ? t("promo_codes.expiry_date") : "Expiry Date"}*`,
        width: "47%",
        InputLabelProps: {
          shrink: true,
        },
      },
    ],
  },
];

export const validationSchema = (t) =>
  Yup.object({
    code: Yup.string().required(t ? t("vendors.error_required") : "Required"),
    discount_percentage: Yup.number()
      .required(t ? t("vendors.error_required") : "Required")
      .min(0, t ? t("vendors.error_required") : "Must be positive")
      .max(100, t ? t("vendors.error_required") : "Must be less than 100"),
    max_discount_amount: Yup.number()
      .required(t ? t("vendors.error_required") : "Required")
      .min(0, t ? t("vendors.error_required") : "Must be positive"),
    min_order_value: Yup.number()
      .required(t ? t("vendors.error_required") : "Required")
      .min(0, t ? t("vendors.error_required") : "Must be positive"),
    expiry_date: Yup.date().required(t ? t("vendors.error_required") : "Required"),
  });
